import { render } from "./CreateAccountConfirm.vue?vue&type=template&id=6ffb1bdc"
const script = {}

import exportComponent from "/home/forge/princes-trust.ac.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__